import { TextField } from "@mui/material"
import { useFormContext } from "react-hook-form"
import { FormComponent } from "./FormBuilder/types"

const MAX_LENGTH_INPUT = 500

type InputProps = {
  field: string
  component: FormComponent
  width?: string
  helperText?: string
}

export const NumberInput = ({ field, component, width = "450px", helperText = "" }: InputProps) => {
  const { register } = useFormContext()
  return (
    <TextField
      required={!!component.required}
      disabled={!component.editable}
      inputProps={{
        maxLength: MAX_LENGTH_INPUT,
      }}
      type="number"
      variant="outlined"
      size="small"
      helperText={helperText}
      error={!!helperText}
      sx={{ width: `${width}` }}
      {...register(field)}
    />
  )
}
